import { ModelBase, Rules, Validation } from '@singularsystems/neo-core';

export default class CountryDTO extends ModelBase {
    static typeName = "CountryDTO";

    constructor() {
        super();
        this.makeObservable();
    }

    public countryId: number = 0;

    @Rules.Required()
    @Rules.StringLength(100)
    public countryName: string = "";

    @Rules.Required()
    @Rules.StringLength(100)
    public sourceCountryName: string = "";

    @Rules.Required()
    @Rules.StringLength(2)
    public countryCode: string = "";

    public currencyId: number = 0;

    @Rules.Required()
    @Rules.StringLength(3)
    public currencyCode: string = "";

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<CountryDTO>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.countryName) {
            return "New country dto";
        } else {
            return this.countryName;
        }
    }
}